import layout from '@/layout'

export default {
  path: '/permission',
  component: layout,
  redirect: '/permission/admin',
  name: 'permissionAdmins',
  meta: {
    title: '权限',
    icon: 'lock'
  },
  children: [
    {
      path: '/permission/admin',
      name: 'permissionAdmin',
      component: () => import('@/views/permission/admin/index'),
      meta: {
        title: '管理员列表',
        icon: 'admin'
      }
    },
    {
      path: '/permission/role',
      name: 'permissionRole',
      component: () => import('@/views/permission/role/index'),
      meta: {
        title: '角色列表',
        icon: 'role'
      }
    },
    {
      path: '/permission/mark',
      name: 'permissionMark',
      component: () => import('@/views/permission/mark/index'),
      meta: {
        title: '权限资源',
        icon: 'mark'
      }
    }
  ]
}
